import React, {useState} from 'react';
import { getIn } from "formik";
import {Button, Modal} from "react-bootstrap";
import DocumentPreviewModal from "../DocumentPreviewModal";

const UploadDocument = (props) => {
    const { index, values, setFieldValue, name, label } = props;
    const [previewModal, setPreviewModal] = useState(false);
    const style = {backgroundColor: '#0C7800', color: '#FFFFFF'}

    const handleSelectedFile = e => {
        const file = e.currentTarget.files[0];

        const MAX_FILE_SIZE = 10 * 1000000;
        if (file.size > MAX_FILE_SIZE) {
            e.target.value = null;
            alert("Ukuran maksimum dokumen adalah 10 MB");
            return;
        }

        setFieldValue(`documents.${index}.type`, name);
        setFieldValue(`documents.${index}.label`, label);
        setFieldValue(`documents.${index}.fileName`, file.name);
        setFieldValue(`documents.${index}.file`, file);

        const fileReader = new FileReader();
        fileReader.onload = (e) => {
            const { result } = e.target;
            setFieldValue(`documents.${index}.dataUrl`, result);
        }
        fileReader.readAsDataURL(file);
    }

    const openPdfDocumentPreview = () => {
        const base64 = getIn(values, `documents.${index}.dataUrl`);

        const binStr = atob(base64.split(',')[1]);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[ i ] = binStr.charCodeAt( i );
        }

        const blob = new Blob([arr], {type: 'application/pdf'});
        const url = URL.createObjectURL(blob);
        let win = window.open("", "_blank");
        win.document.open();
        win.document.write('<iframe src="' + url + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
        win.document.close();
    }

    const onClickDocumentPreview = () => {
        if (getIn(values, `documents.${index}.file.type`) === 'application/pdf') {
            openPdfDocumentPreview();
            return;
        }

        setPreviewModal(true);
    }

    const onClickDeleteDocument = () => {
        setFieldValue(`documents.${index}`, null);
    }

    return <div className={'mt-3'}>
        <h6>{props.label}</h6>
        <div className={'d-flex'}>
            <div className={'w-75 overflow-hidden'}>
                <input id={props.name} name={`documents.${index}.file`} type={'file'} style={{display: 'none'}}
                    onChange={(e) => handleSelectedFile(e)} 
                    onClick={(e)=> { 
                        e.currentTarget.value = null
                    }}
                    accept="image/jpeg,image/png,application/pdf" />
                <div className={'d-flex'}>
                    <div className={'input-group'}>
                        <label htmlFor={props.name} className={'form-control overflow-hidden'}>
                            {getIn(values, `documents.${index}.fileName`) ?? 'Pilih Dokumen'}
                        </label>
                        {getIn(values, `documents.${index}.fileName`) &&
                        <button className="input-group-text" onClick={() => onClickDeleteDocument()}>
                            Hapus
                        </button>
                        }
                        <label htmlFor={props.name} style={style} className="input-group-text">
                            {getIn(values, `documents.${index}.fileName`) ? 'Ganti' : 'Upload'}
                        </label>
                    </div>
                </div>
            </div>
            {getIn(values, `documents.${index}.dataUrl`) &&
            <div className={'my-auto'}>
                <a href="#" className='ps-2'
                    onClick={() => onClickDocumentPreview()}>Lihat Dokumen</a>
            </div>
            }
        </div>
        {getIn(values, `documents.${index}.dataUrl`) &&
        <DocumentPreviewModal {...previewModal} show={previewModal} onHide={() => setPreviewModal(false)} values={values} index={index}/>
        }
    </div>
}

export default UploadDocument;